import queries from '@apis/queries';
import { ACCESS_TOKEN_MAX_AGE_SECOND, REFRESH_TOKEN_MAX_AGE_SECOND } from '@constants/auth';
import useNativeListener from '@hooks/useNativeListener';
import { SignInResponse } from '@models/auth';
import { useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { useCookies } from 'react-cookie';

function reissueToken(refreshToken: string): Promise<AxiosResponse<SignInResponse>> {
  return axios.post(
    `${import.meta.env.VITE_API_URL}/auth/token/refresh`,
    { refreshToken },
  );
}

function useLifeCycleReIssue() {
  const [cookies, setCookies] = useCookies(['accessToken', 'refreshToken']);
  const { refreshToken } = cookies;
  const queryClient = useQueryClient();

  // 네이티브를 통해 재접속으 확인하면 토큰 재발급
  useNativeListener('noticeLifecycle', async () => {
    console.log('라이프 사이클 변경');
    try {
      if (refreshToken) {
        const res = (await reissueToken(refreshToken)).data;
        setCookies('accessToken', res.token, {
          path: '/',
          maxAge: ACCESS_TOKEN_MAX_AGE_SECOND,
        });
        setCookies('refreshToken', res.refreshToken, {
          path: '/',
          maxAge: REFRESH_TOKEN_MAX_AGE_SECOND,
        });
        queryClient.invalidateQueries({ queryKey: queries.user._def });
        queryClient.invalidateQueries({ queryKey: queries.cart._def });
        queryClient.invalidateQueries({ queryKey: queries.notifications._def });
        queryClient.invalidateQueries({ queryKey: queries.stamps._def });
        queryClient.invalidateQueries({ queryKey: queries.coupons._def });
        queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
        queryClient.invalidateQueries({ queryKey: queries.shop._def });
        queryClient.invalidateQueries();
        console.log('refresh on resume');
      }
    } catch (e) {
      console.error('lifecycle fetch', e);
    }
  }, [refreshToken]);
}

export default useLifeCycleReIssue;
